<div class="g_modal-dialog g_backdrop">
    <div class="g_dialog-container info-modal-window"
         (click)="$event.stopPropagation()"
         (mousedown)="$event.stopPropagation()">


        <div class="g_dialog-header">
            <div>Service gesperrt, bis Vereinbarung akzeptiert wurde</div>
        </div>


        <div class="g_dialog-content">
            Zur Nutzung der Service-Schulungsseite müssen Sie die Vereinbarung akzeptieren. Bis dahin ist die Nutzung leider nicht möglich.
        </div>


        <div class="g_dialog-footer">
            <button class="btn btn-primary w-100" (click)="closeModal()">Schließen</button>
        </div>

    </div>

</div>
